
export enum CategoriaArquivo {
  DOCUMENTO = 'DOCUMENTO',
  IMAGEM = 'IMAGEM',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
  OUTROS = 'OUTROS',
  GEOGRAFICO = 'GEOGRAFICO'
}
